import BaseApi from './base'

class ScwPatent extends BaseApi {
  getScwPatents = (query) => this.client.get(`admin/scw-patent?${query}`)

  getScwPatent = (id) => this.client.get(`admin/scw-patent/${id}`)

  addScwPatent = (data) => this.client.post('admin/scw-patent', data)

  updateScwPatent = ({ patentId, payload }) =>
    this.client.patch(`admin/scw-patent/${patentId}`, payload)

  updateScwPatentStatus = ({ patentId, payload }) =>
    this.client.patch(`admin/scw-patent/${patentId}/status`, payload)

  deleteScwPatent = (id) => this.client.delete(`admin/scw-patent/${id}`)

  upsertScwPatentContent = ({ patentId, languageId, payload }) =>
    this.client.post(
      `admin/scw-patent/${patentId}/product/${languageId}`,
      payload
    )

  getScwPatentContent = ({ patentId, languageId }) =>
    this.client.get(`admin/scw-patent/${patentId}/product/${languageId}`)
}

export default new ScwPatent()
